import React from 'react';
import { Modal, Typography, Space } from 'antd';
import { LEGAL_PAGE_CONTENT, LegalSection } from '../../data/legalPages';

const { Paragraph } = Typography;

type Props = {
  open: boolean;
  section: LegalSection;
  onClose: () => void;
};

const LegalInfoModal: React.FC<Props> = ({ open, section, onClose }) => {
  const { title, paragraphs } = LEGAL_PAGE_CONTENT[section];

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
      destroyOnClose
      centered
      styles={{
        body: { maxHeight: '70vh', overflowY: 'auto', paddingTop: 4 },
      }}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        {paragraphs.map((text, index) => (
          <Paragraph
            key={index}
            style={{
              marginBottom: 0,
              color: 'var(--text-secondary)',
              fontSize: 15,
              lineHeight: 1.65,
              whiteSpace: 'pre-wrap'
            }}
          >
            {text}
          </Paragraph>
        ))}
      </Space>
    </Modal>
  );
};

export default LegalInfoModal;
